module.exports = __webpack_public_path__ + "static/media/clouds.cdbeaed3.png";